import React from 'react';
import { ScreenWrapper } from './Login';
import Pin from '../components/Pin';

const PinScreen = () => (
  <ScreenWrapper>
    <Pin />
  </ScreenWrapper>
);

export default PinScreen;
